import React from 'react'
import { useT } from '@transifex/react'
import {
  useRegisterManager,
  useRetailerSettingsManager,
} from '../../../ng-compat/hooks'
import { dateFormat } from '../../../filters/wr-date-format'

// Quick Receipt
interface Props {
  title: string
  subTitle?: string
  items: React.ReactNode
}

export const QuickReceipt: React.FC<Props> = ({ title, subTitle, items }) => {
  const retailerSettingsManager = useRetailerSettingsManager()

  return (
    <article className="wr-quick-receipt">
      <header className="vd-align-center">
        <div className="vd-align-left vd-text-supplementary vd-mb6">
          {retailerSettingsManager.get().name}
        </div>
        <div className="vd-text-label">{title}</div>
        {subTitle && <div className="vd-text-hero">{subTitle}</div>}
      </header>

      <section className="wr-quick-receipt-section vd-mt3 vd-pt3 vd-pb3">
        <ul>{items}</ul>
      </section>
    </article>
  )
}

// List Item Component
interface QuickReceiptListItemProps {
  label: string
  value?: string
}

export const QuickReceiptListItem: React.FC<QuickReceiptListItemProps> = ({
  label,
  value,
}) => (
  <li className="wr-quick-receipt-item">
    <div className="wr-quick-receipt-item-key">{label}:</div>
    <div>{value}</div>
  </li>
)

// List Date Item Component
interface QuickReceiptDateItemProps {
  label?: string
  value: string
}

export const QuickReceiptDateItem: React.FC<QuickReceiptDateItemProps> = ({
  label,
  value,
}) => {
  const registerManager = useRegisterManager()
  const outlet = registerManager.getActiveOutlet()
  const t = useT()
  const translatedLabel = label || t('Date')

  return (
    <QuickReceiptListItem
      label={translatedLabel}
      value={dateFormat(value, 'D MMM, YYYY @ h:mma', outlet.time_zone)}
    />
  )
}

// List Register Item Component
interface QuickReceiptRegisterItemProps {
  label?: string
}

export const QuickReceiptRegisterItem: React.FC<QuickReceiptRegisterItemProps> = ({
  label,
}) => {
  const registerManager = useRegisterManager()
  const register = registerManager.getActiveRegister()
  const t = useT()
  const translatedLabel = label || t('Register')

  return <QuickReceiptListItem label={translatedLabel} value={register.name} />
}
